import React, { useState } from 'react';
import CommonFilter from '../../atoms/CommonFilter';

// Example filters configuration
const filterOptions = [
  {
    id: 'status',
    label: 'Status',
    type: 'multi-select' ,
    options:    [  { value: "tech", label: "Technology" },
    { value: "health", label: "Health" },
    { value: "finance", label: "Finance" }],
  },
  {
    id: 'priority',
    label: 'Priority',
    type: 'multi-select' ,
    options:    [  { value: "tech", label: "Technology" },
      { value: "health", label: "Health" },
      { value: "finance", label: "Finance" }],
  },
  {
    id: 'assignee',
    label: 'Assignee',
    type: 'multi-select',
    options: ['John Doe', 'Jane Smith', 'Bob Johnson', 'Alice Brown', 'Unassigned'],
  },
  {
    id: 'project',
    label: 'Project',
    type: 'multi-select' ,
    options: ['Frontend App', 'Backend API', 'Mobile App', 'Documentation', 'DevOps'],
  },
];

const None =() => {
  const [filters, setFilters] = useState({});

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <h1 className="h3 mb-4">Employee Filter Demo</h1>
          
          <CommonFilter
            filters={filterOptions}
            onFilterChange={handleFilterChange}
          />

          
        </div>
      </div>
    </div>
  );
}

export default None